import { SVGProps } from 'react';

import { Addon } from './addon';
import { Status } from './admission';
import { BookingFormField } from './booking-form-field';
import { Translations } from './preset';
import { Price } from './price';
import { TicketHolderFormField } from './ticket-holder-form-field';

export const PASS_TYPE_DEFAULT = 'default';
export const PASS_TYPE_STAFF = 'staffPass';
export const PASS_TYPE_SEASON = 'seasonPass';

interface Settings {
  channelDefaultMaxQuantity: number | null;
  isForAllChannels: boolean;
  isHidden: boolean;
  isPrivate: boolean;
  isNominative: boolean;
}

interface Commissions {
  transactionFee: number;
  transactionFeeStrategy: string | null;
  xceedCommission: number;
  xceedCommissionStrategy: number | null;
  transactionFeeAbsorbed: number;
}

export const PASS_DAY_MONDAY = 'monday';
export const PASS_DAY_TUESDAY = 'tuesday';
export const PASS_DAY_WEDNESDAY = 'wednesday';
export const PASS_DAY_THURSDAY = 'thursday';
export const PASS_DAY_FRIDAY = 'friday';
export const PASS_DAY_SATURDAY = 'saturday';
export const PASS_DAY_SUNDAY = 'sunday';

export type PassDay =
  | typeof PASS_DAY_FRIDAY
  | typeof PASS_DAY_MONDAY
  | typeof PASS_DAY_SATURDAY
  | typeof PASS_DAY_SUNDAY
  | typeof PASS_DAY_THURSDAY
  | typeof PASS_DAY_TUESDAY
  | typeof PASS_DAY_WEDNESDAY;

export interface PassHolders {
  active: number;
  inactive: number;
}

export interface Pass {
  id: string;
  status: Status;
  isDraft: boolean;
  price: Price;
  onlinePaymentPercentage: number;
  quantity: number | null;
  soldItems: number;
  itemsPerTransaction: {
    min: number;
    max: number;
  };
  salesTime: {
    openingTime: number;
    closingTime: number;
  };
  salesStatus: {
    isSalesClosed: boolean;
    isSoldOut: boolean;
  };
  settings: Settings;
  commissions: Commissions;
  name: Translations;
  description: Translations;
  images: string[];
  bookingFormFields: BookingFormField[];
  accessCode: string | null;
  updatedAt: number;
  addOns: Addon[];
  passType: string;
  companyId: string;
  passValidity: {
    validFrom: number;
    validUntil: number;
    passDayValidity: PassDay[];
  };
  passHolders: PassHolders;
  checkInTime: {
    validFrom: number | null;
    validUntil: number | null;
  };
  ticketHolderFormFields: TicketHolderFormField[];
  color: string | null;
}

export interface EventPass extends Pass {
  isActive: boolean;
}

export interface EventPasses {
  staffPass: EventPass[];
  seasonPass: EventPass[];
}

export type PassModalStepType = typeof PASS_TYPE_DEFAULT | typeof PASS_TYPE_SEASON | typeof PASS_TYPE_STAFF;

export type PassType = typeof PASS_TYPE_SEASON | typeof PASS_TYPE_STAFF;

export interface PassesTypeArray {
  name: PassType;
  title: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  className: string;
}

export interface GetPassesResponse {
  [PASS_TYPE_SEASON]: Pass[];
  [PASS_TYPE_STAFF]: Pass[];
}
